<template>
  <div>
    <div class="row invisible-print">
      <div class="col-md-12">
        <label>Data Pagamento:</label>
        <date-range-picker 
          ref="date-range-picker" 
          opens="left" 
          :locale-data="localData" 
          :autoApply="true" 
          :disabled="isLoading" 
          v-model="dateRange" 
          :ranges="ranges" 
          @update="updateDatas" 
          style="width: 100%"
        >
          <template v-slot:input="picker">
            <div v-if="picker.startDate && picker.endDate" style="min-width: 350px">
              {{ formataDataObject(picker.startDate) }} à {{ formataDataObject(picker.endDate) }}
            </div>
          </template>
        </date-range-picker>
      </div>
    </div>
    <div class="row invisible-print" style="margin-top: 8px; margin-bottom: 16px;">
      <div class="col-md-12">
        <a 
          href="javascript:;" 
          @click="buscar" 
          class="btn btn-block btn-primary font-weight-bolder mr-2" 
          :disabled="isLoading"
        >
          <b-spinner
            v-if="isLoading"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Buscar
        </a>
      </div>
    </div>
    <div class="row invisible-print">
      <div class="col-md-12">
        <label>Data Prevista Transferência:</label>
        <date-range-picker 
          ref="date-range-picker" 
          opens="left" 
          :locale-data="localData" 
          :autoApply="true" 
          :disabled="isLoading" 
          v-model="dateRangeTransferencias" 
          :ranges="ranges" 
          @update="updateDatas" 
          style="width: 100%"
        >
          <template v-slot:input="picker">
            <div v-if="picker.startDate && picker.endDate" style="min-width: 350px">
              {{ formataDataObject(picker.startDate) }} à {{ formataDataObject(picker.endDate) }}
            </div>
          </template>
        </date-range-picker>
      </div>
    </div>
    <div class="row invisible-print" style="margin-top: 8px; margin-bottom: 16px;">
      <div class="col-md-12">
        <a 
          href="javascript:;" 
          @click="buscarTransferencias" 
          class="btn btn-block btn-primary font-weight-bolder mr-2" 
          :disabled="isLoading"
        >
          <b-spinner
            v-if="isLoading"
            small
            style="margin-bottom: 2px; margin-right: 3px"
          ></b-spinner>
          Buscar Transferências
        </a>
      </div>
    </div>
    <div class="row" v-if="fluxos.length">
      <div class="col-md-12">
        <div class="card card-custom position-relative overflow-hidden">
          <!--begin::Shape-->
          <div class="position-absolute opacity-30">
            <span class="svg-icon svg-icon-10x svg-logo-white">
              <!--begin::Svg Icon | path:/metronic/theme/html/demo3/dist/assets/media/svg/shapes/abstract-8.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="176"
                height="165"
                viewBox="0 0 176 165"
                fill="none"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M-10.001 135.168C-10.001 151.643 3.87924 165.001 20.9985 165.001C38.1196 165.001 51.998 151.643 51.998 135.168C51.998 118.691 38.1196 105.335 20.9985 105.335C3.87924 105.335 -10.001 118.691 -10.001 135.168Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M28.749 64.3117C28.749 78.7296 40.8927 90.4163 55.8745 90.4163C70.8563 90.4163 83 78.7296 83 64.3117C83 49.8954 70.8563 38.207 55.8745 38.207C40.8927 38.207 28.749 49.8954 28.749 64.3117Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M82.9996 120.249C82.9996 144.964 103.819 165 129.501 165C155.181 165 176 144.964 176 120.249C176 95.5342 155.181 75.5 129.501 75.5C103.819 75.5 82.9996 95.5342 82.9996 120.249Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M98.4976 23.2928C98.4976 43.8887 115.848 60.5856 137.249 60.5856C158.65 60.5856 176 43.8887 176 23.2928C176 2.69692 158.65 -14 137.249 -14C115.848 -14 98.4976 2.69692 98.4976 23.2928Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M-10.0011 8.37466C-10.0011 20.7322 0.409554 30.7493 13.2503 30.7493C26.0911 30.7493 36.5 20.7322 36.5 8.37466C36.5 -3.98287 26.0911 -14 13.2503 -14C0.409554 -14 -10.0011 -3.98287 -10.0011 8.37466Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M-2.24881 82.9565C-2.24881 87.0757 1.22081 90.4147 5.50108 90.4147C9.78135 90.4147 13.251 87.0757 13.251 82.9565C13.251 78.839 9.78135 75.5 5.50108 75.5C1.22081 75.5 -2.24881 78.839 -2.24881 82.9565Z"
                    fill="#AD84FF"
                  ></path>
                  <path
                    d="M55.8744 12.1044C55.8744 18.2841 61.0788 23.2926 67.5001 23.2926C73.9196 23.2926 79.124 18.2841 79.124 12.1044C79.124 5.92653 73.9196 0.917969 67.5001 0.917969C61.0788 0.917969 55.8744 5.92653 55.8744 12.1044Z"
                    fill="#AD84FF"
                  ></path>
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
          </div>
          <!--end::Shape-->
          <!--begin::Invoice header-->
          <div
            class="
              row
              justify-content-center
              py-8
              px-8
              py-md-36
              px-md-0
              bg-primary
            "
          >
            <div class="col-md-9">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-md-center
                  flex-column flex-md-row
                "
              >
                <div class="d-flex flex-column px-0 order-2 order-md-1">
                  <!--begin::Logo-->
                  <a href="#" class="mb-5 max-w-115px">
                    <span class="svg-icon svg-icon-full svg-logo-white">
                      <img src="media/logos/paylogos_logo2.png" style="height: 50px; margin-left: -14px;" />
                    </span>
                  </a>
                  <!--end::Logo-->
                  <span
                    class="
                      d-flex
                      flex-column
                      font-size-h5 font-weight-bold
                      text-white
                    "
                  >
                    <span>Relatório de recebíveis pagos por {{ retornaTituloBuscaData() }}</span>
                    <span>{{ formataDataObject(dateRange.startDate) }} à {{ formataDataObject(dateRange.endDate) }}</span>
                  </span>
                </div>
                <h1
                  class="
                    display-3
                    font-weight-boldest
                    text-white
                    order-1 order-md-2
                  "
                  style="font-size: 40px !important;"
                >
                  RECEBIMENTOS
                </h1>
              </div>
            </div>
          </div>
          <!--end::Invoice header-->
          <div class="row justify-content-center py-8 px-8 py-md-30 px-md-0">
            <div class="col-md-12">
              <!--begin::Invoice body-->
              <div class="row" style="margin-left: 20px; margin-right: 20px;">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th
                            class="
                              pt-1
                              pb-9
                              pl-0 pl-md-5
                              font-weight-bolder
                              text-muted
                              font-size-lg
                              text-uppercase
                            "
                          >
                            Emitente
                          </th>
                          <th
                            class="
                              pt-1
                              pb-9
                              text-right
                              font-weight-bolder
                              text-muted
                              font-size-lg
                              text-uppercase
                            "
                          >
                            Descrição
                          </th>
                          <th
                            class="
                              pt-1
                              pb-9
                              text-right
                              font-weight-bolder
                              text-muted
                              font-size-lg
                              text-uppercase
                            "
                          >
                            Forma de Pagamento
                          </th>
                          <th
                            class="
                              pt-1
                              pb-9
                              text-right
                              font-weight-bolder
                              text-muted
                              font-size-lg
                              text-uppercase
                            "
                          >
                            Data Pagamento
                          </th>
                          <th
                            class="
                              pt-1
                              pb-9
                              text-right
                              pr-0
                              font-weight-bolder
                              text-muted
                              font-size-lg
                              text-uppercase
                            "
                          >
                            Valor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="
                            font-weight-bolder
                            border-bottom-0
                            font-size-lg
                          "
                          v-for="fluxo in fluxos"
                          :key="fluxo.ID_FLUXO_DE_CAIXA"
                        >
                          <td
                            class="
                              border-top-0
                              pl-0 pl-md-5
                              py-4
                              d-flex
                              align-items-center
                            "
                          >
                            <span class="navi-icon mr-2">
                              <i
                                class="
                                  fa fa-genderless
                                  text-primary
                                  font-size-h2
                                "
                              ></i>
                            </span>
                            {{ (fluxo.EMITENTE) ? fluxo.EMITENTE : (((fluxo.TRANSACAO) && (fluxo.TRANSACAO.COMPRADOR) && (fluxo.TRANSACAO.COMPRADOR.NOME)) ? fluxo.TRANSACAO.COMPRADOR.NOME : '') }} <br />
                            {{ fluxo.EMITENTE_PESSOA == "F" ?  "CPF: " : "CNPJ: " }} {{ retornaCPFCNPJFormatado(fluxo) }} <br />
                            {{ retornaTransacaoId(fluxo) }}
                          </td>
                          <td class="border-top-0 text-right py-4">{{ retornaDescricaoFluxo(fluxo) }}</td>
                          <td class="border-top-0 text-right py-4">
                            {{ retornaFormaPagamento(fluxo) }} - {{ retornaBandeiraCartao(fluxo) }} - {{ retornaParcelas(fluxo) }}x <br />
                            {{ retornaTransacaoAutorizacao(fluxo) }}
                          </td>
                          <td class="border-top-0 text-right py-4">
                            {{ formataDataPagamento(fluxo) }}
                          </td>
                          <td
                            class="
                              border-top-0
                              pr-0
                              py-4
                              font-size-h6 font-weight-boldest
                              text-right
                            "
                          >
                            {{ formataValor(fluxo.VALOR) }} <br />
                            <span style="font-size: 11px; display: block;">Líquido: {{ formataValor(parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) }}</span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_1" style="font-size: 11px; display: block;">
                              Parcela 1: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_1) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_2" style="font-size: 11px; display: block;">
                              Parcela 2: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_2) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_3" style="font-size: 11px; display: block;">
                              Parcela 3: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_3) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_4" style="font-size: 11px; display: block;">
                              Parcela 4: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_4) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_5" style="font-size: 11px; display: block;">
                              Parcela 5: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_5) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_6" style="font-size: 11px; display: block;">
                              Parcela 6: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_6) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_7" style="font-size: 11px; display: block;">
                              Parcela 7: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_7) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_8" style="font-size: 11px; display: block;">
                              Parcela 8: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_8) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_9" style="font-size: 11px; display: block;">
                              Parcela 9: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_9) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_10" style="font-size: 11px; display: block;">
                              Parcela 10: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_10) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_11" style="font-size: 11px; display: block;">
                              Parcela 11: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_11) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>
                            <span v-if="fluxo.TRANSACAO.DATA_TRANSFERENCIA_12" style="font-size: 11px; display: block;">
                              Parcela 12: {{ formataData(fluxo.TRANSACAO.DATA_TRANSFERENCIA_12) }} - {{ formataValor((parseFloat(fluxo.TRANSACAO.VALOR_PAGO) - parseFloat(fluxo.TRANSACAO.VALOR_TAXAS)) / parseInt(fluxo.TRANSACAO.PARCELAS)) }}
                            </span>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--end::Invoice body-->
              <!--begin::Invoice footer-->
              <div class="row" style="margin-left: 20px; margin-right: 20px;">
                <div class="col-md-5 pt-14 pb-10 pb-md-18">
                  <div class="d-flex flex-column flex-md-row">
                    <div class="d-flex flex-column">
                      <!--<div class="font-weight-bold font-size-h6 mb-3">
                        BANK TRANSFER
                      </div>
                      <div
                        class="d-flex justify-content-between font-size-lg mb-3"
                      >
                        <span class="font-weight-bold mr-15"
                          >Account Name:</span
                        >
                        <span class="text-right">Barclays UK</span>
                      </div>
                      <div
                        class="d-flex justify-content-between font-size-lg mb-3"
                      >
                        <span class="font-weight-bold mr-15"
                          >Account Number:</span
                        >
                        <span class="text-right">1234567890934</span>
                      </div>
                      <div class="d-flex justify-content-between font-size-lg">
                        <span class="font-weight-bold mr-15">Code:</span>
                        <span class="text-right">BARC0032UK</span>
                      </div>-->
                    </div>
                  </div>
                </div>
                <div class="col-md-7 pt-md-25">
                  <div
                    class="
                      bg-primary
                      rounded
                      d-flex
                      align-items-center
                      justify-content-between
                      text-white
                      max-w-350px
                      position-relative
                      ml-auto
                      p-7
                    "
                  >
                    <!--begin::Shape-->
                    <div class="position-absolute opacity-30 top-0 right-0">
                      <span
                        class="
                          svg-icon svg-icon-2x svg-logo-white svg-icon-flip
                        "
                      >
                        <!--begin::Svg Icon | path:/metronic/theme/html/demo3/dist/assets/media/svg/shapes/abstract-8.svg-->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="176"
                          height="165"
                          viewBox="0 0 176 165"
                          fill="none"
                        >
                          <g clip-path="url(#clip0)">
                            <path
                              d="M-10.001 135.168C-10.001 151.643 3.87924 165.001 20.9985 165.001C38.1196 165.001 51.998 151.643 51.998 135.168C51.998 118.691 38.1196 105.335 20.9985 105.335C3.87924 105.335 -10.001 118.691 -10.001 135.168Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M28.749 64.3117C28.749 78.7296 40.8927 90.4163 55.8745 90.4163C70.8563 90.4163 83 78.7296 83 64.3117C83 49.8954 70.8563 38.207 55.8745 38.207C40.8927 38.207 28.749 49.8954 28.749 64.3117Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M82.9996 120.249C82.9996 144.964 103.819 165 129.501 165C155.181 165 176 144.964 176 120.249C176 95.5342 155.181 75.5 129.501 75.5C103.819 75.5 82.9996 95.5342 82.9996 120.249Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M98.4976 23.2928C98.4976 43.8887 115.848 60.5856 137.249 60.5856C158.65 60.5856 176 43.8887 176 23.2928C176 2.69692 158.65 -14 137.249 -14C115.848 -14 98.4976 2.69692 98.4976 23.2928Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M-10.0011 8.37466C-10.0011 20.7322 0.409554 30.7493 13.2503 30.7493C26.0911 30.7493 36.5 20.7322 36.5 8.37466C36.5 -3.98287 26.0911 -14 13.2503 -14C0.409554 -14 -10.0011 -3.98287 -10.0011 8.37466Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M-2.24881 82.9565C-2.24881 87.0757 1.22081 90.4147 5.50108 90.4147C9.78135 90.4147 13.251 87.0757 13.251 82.9565C13.251 78.839 9.78135 75.5 5.50108 75.5C1.22081 75.5 -2.24881 78.839 -2.24881 82.9565Z"
                              fill="#AD84FF"
                            ></path>
                            <path
                              d="M55.8744 12.1044C55.8744 18.2841 61.0788 23.2926 67.5001 23.2926C73.9196 23.2926 79.124 18.2841 79.124 12.1044C79.124 5.92653 73.9196 0.917969 67.5001 0.917969C61.0788 0.917969 55.8744 5.92653 55.8744 12.1044Z"
                              fill="#AD84FF"
                            ></path>
                          </g>
                        </svg>
                        <!--end::Svg Icon-->
                      </span>
                    </div>
                    <!--end::Shape-->
                    <div class="font-weight-boldest font-size-h5">
                      VALOR TOTAL
                    </div>
                    <div class="text-right d-flex flex-column">
                      <span class="font-weight-boldest font-size-h3 line-height-sm">
                        {{ retornaValorTotal() }}
                      </span>
                      <span class="font-size-sm"></span>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Invoice footer-->
            </div>
          </div>
          <!-- begin: Invoice action-->
          <div
            class="
              row
              justify-content-center
              border-top
              py-8
              px-8
              py-md-28
              px-md-0 
              invisible-print
            "
          >
            <div class="col-md-9">
              <div class="d-flex font-size-sm flex-wrap">
                <button
                  type="button"
                  class="
                    btn btn-block btn-primary
                    font-weight-bolder
                    py-4
                    mr-3 mr-sm-14
                    my-1
                  "
                  onclick="window.print();"
                  style="margin: 0 !important;"
                >
                  Imprimir Relatório
                </button>
                <button
                  type="button"
                  class="
                    btn btn-block btn-primary
                    font-weight-bolder
                    py-4
                    mr-3 mr-sm-14
                    my-1
                  "
                  @click="exportarExcel"
                  style="margin: 0 !important; margin-top: 10px !important;"
                >
                  Exportar Relatório Excel
                </button>
              </div>
            </div>
          </div>
          <!-- end: Invoice action-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "Recebimentos",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      isLoading: false,
      ordenacaoFiltroTipo: "vencimento",
      dataFiltroTipo: "vencimento",
      dataFiltros: [
        { value: "vencimento", text: "Vencimento" },
        { value: "pagamento", text: "Pagamento" },
        { value: "credito", text: "Crédito" },
        { value: "emissao", text: "Emissão" },
        { value: "inclusao", text: "Inclusão" },
        { value: "alteracao", text: "Alteração" },
        { value: "emitente", text: "Emitente" },
      ],
      ordenacaoFiltros: [
        { value: "vencimento", text: "Vencimento" },
        { value: "pagamento", text: "Pagamento" },
        { value: "credito", text: "Crédito" },
        { value: "emissao", text: "Emissão" },
        { value: "inclusao", text: "Inclusão" },
        { value: "alteracao", text: "Alteração" },
        { value: "emitente", text: "Emitente" },
        { value: "valor", text: "Valor" },
      ],
      dateRange: {
        startDate: null,
        endDate: null,
      },
      dateRangeTransferencias: {
        startDate: null,
        endDate: null,
      },
      localData: {
        firstDay: 1,
        format: "yyyy-mm-dd HH:mm:ss",
        daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        monthNames: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
      },
      ranges: {
        Hoje: [moment().toDate(), moment().toDate()],
        Ontem: [
          moment().subtract(1, "days").toDate(),
          moment().subtract(1, "days").toDate(),
        ],
        "Mês atual": [
          moment().startOf("month").toDate(),
          moment().endOf("month").toDate(),
        ],
        "Mês passado": [
          moment().subtract(1, "month").startOf("month").toDate(),
          moment().subtract(1, "month").endOf("month").toDate(),
        ],
        "Ano atual": [
          moment().startOf("year").toDate(),
          moment().endOf("year").toDate(),
        ],
      },
      fluxos: []
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Relatórios", route: "recebimentos" },
      { title: "Recebimentos" },
    ]);

    moment.locale("pt-br");

    this.dateRange.startDate = moment().toDate();
    this.dateRange.endDate = moment().toDate();

    this.dateRangeTransferencias.startDate = moment().toDate();
    this.dateRangeTransferencias.endDate = moment().toDate();
  },
  computed: {
    ...mapGetters([
      "emitentePrincipal"
    ])
  },
  methods: {
    ...mapActions([
      "getRelatoriosRecebimentos"
    ]),
    setOrdenacaoData() {},
    setFiltroData() {},
    updateDatas() {},
    formataDataObject(data) {
      if (data) {
        return moment(data).format("DD/MM/YYYY");
      } else {
        return "";
      }
    }, 
    async buscar() {
      this.isLoading = true;
      this.fluxos = await this.getRelatoriosRecebimentos({
        dataIni: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        dataFim: moment(this.dateRange.endDate).format("YYYY-MM-DD")
      });
      this.isLoading = false;
    }, 
    async buscarTransferencias() {
      this.isLoading = true;
      this.fluxos = await this.getRelatoriosRecebimentos({
        dataIni: moment(this.dateRangeTransferencias.startDate).format("YYYY-MM-DD"), 
        dataFim: moment(this.dateRangeTransferencias.endDate).format("YYYY-MM-DD"), 
        dataTransferencia: true
      });
      this.isLoading = false;
    }, 
    retornaDescricaoFluxo(fluxo) {
      return (fluxo.PROJETO) ? fluxo.PROJETO : fluxo.HISTORICO;
    }, 
    retornaCPFCNPJFormatado(fluxo) {
      if(fluxo.EMITENTE_CGC_CPF) {
        if(fluxo.EMITENTE_PESSOA == "F") {
          return fluxo.EMITENTE_CGC_CPF.replace(/[^\d]/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        } else {
          return fluxo.EMITENTE_CGC_CPF.replace(/[^\d]/g, "").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
      } else {
        return "";
      }
    },
    formataData(data) {
      return moment(data, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY");
    },
    formataDataPagamento(fluxo) {
      if(
        (fluxo) && 
        (fluxo.TRANSACAO)
      ) {
        if(fluxo.TRANSACAO.DATA_PAGAMENTO) {
          return moment(fluxo.TRANSACAO.DATA_PAGAMENTO, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    formataValor(valor) {
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    retornaValorTotal() {
      let valor = 0;
      this.fluxos.forEach((fluxo) => {
        if(fluxo.VALOR) {
          valor += parseFloat(fluxo.VALOR);
        }
      });

      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    retornaTituloBuscaData() {
      let titulo = "";

      this.dataFiltros.forEach((dataFiltro) => {
        if (dataFiltro.value == this.dataFiltroTipo) {
          titulo = dataFiltro.text;
        }
      });
      
      return titulo;
    },
    retornaTransacaoId(fluxo) {
      if((fluxo.TRANSACAO) && (fluxo.TRANSACAO.ID_ZOOP_API)) {
        return fluxo.TRANSACAO.ID_ZOOP_API;
      } else {
        return "";
      }
    },
    retornaTransacaoAutorizacao(fluxo, printAutorizacao = true) {
      if((fluxo.TRANSACAO) && (fluxo.TRANSACAO.CARTAO_CODIGO_AUTORIZACAO)) {
        return (printAutorizacao ? "Autorização: " : "") + fluxo.TRANSACAO.CARTAO_CODIGO_AUTORIZACAO;
      } else if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.MOVIMENTO) && 
        (fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO) && 
        (fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO.payment_authorization) && 
        (fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO.payment_authorization.authorization_code)
      ) {
        return (printAutorizacao ? "Autorização: " : "") + fluxo.TRANSACAO.MOVIMENTO.RECEBIMENTO.payment_authorization.authorization_code;
      } else {
        return "";
      }
    },
    retornaFormaPagamento(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.TIPO_PAGAMENTO)
      ) {
        if(fluxo.TRANSACAO.TIPO_PAGAMENTO == "credit") {
          return "Crédito";
        } else if(fluxo.TRANSACAO.TIPO_PAGAMENTO == "boleto") {
          return "Boleto";
        } else if(fluxo.TRANSACAO.TIPO_PAGAMENTO == "pix") {
          return "PIX";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    retornaBandeiraCartao(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.CARTAO_BANDEIRA)
      ) {
        return fluxo.TRANSACAO.CARTAO_BANDEIRA;
      } else {
        return "";
      }
    },
    retornaParcelas(fluxo) {
      if(
        (fluxo.TRANSACAO) && 
        (fluxo.TRANSACAO.PARCELAS)
      ) {
        return fluxo.TRANSACAO.PARCELAS;
      } else {
        return "";
      }
    },
    exportarExcel() {
      let items = "Emitente;CPF;Código;Descrição;Forma de Pagamento;Autorização;Data Pagamento;Valor\n";

      this.fluxos.forEach((fluxo) => {
        let sAux =  
          ((fluxo.EMITENTE) ? fluxo.EMITENTE : (((fluxo.TRANSACAO) && (fluxo.TRANSACAO.COMPRADOR) && (fluxo.TRANSACAO.COMPRADOR.NOME)) ? fluxo.TRANSACAO.COMPRADOR.NOME : '')) + ";" + 
          this.retornaCPFCNPJFormatado(fluxo) + ";" + 
          this.retornaTransacaoId(fluxo) + ";" + 
          this.retornaDescricaoFluxo(fluxo) + ";" + 
          this.retornaFormaPagamento(fluxo) + " - " + this.retornaBandeiraCartao(fluxo) + " - " + this.retornaParcelas(fluxo) + ";" + 
          this.retornaTransacaoAutorizacao(fluxo, false) + ";" + 
          this.formataDataPagamento(fluxo) + ";" +
          this.formataValor(fluxo.VALOR) + ";" + 
          "\n";
        items += sAux;
      });

      let element = document.createElement('a');
      let universalBOM = "\uFEFF";
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + items));
      element.setAttribute('download', 'relatorio_recebimentos' + moment(this.dateRange.startDate).format("YYYY-MM-DD") + '-a-' + moment(this.dateRange.endDate).format("YYYY-MM-DD") + '.csv');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }
};
</script>

<style>
.calendars .ranges {
  max-width: 140px;
}

.vue-daterange-picker .reportrange-text {
  padding-top: 9px;
  text-align: center;
  border: 1px solid #e4e6ef;
}

.vue-daterange-picker .reportrange-text i {
  display: none;
}

@media (max-width: 767px) {
  .mrg-bottom-cel {
    margin-bottom: 8px;
  }
}
</style>